import component from './CardThumbnailImage';

export default component;
